import { apiRequest } from "../../services/apiService";
import {
    ADD_SURVEY_FAIL, ADD_SURVEY_REQUEST, ADD_SURVEY_SUCCESS, CHANGE_ADD_SURVEY_FORM_DATA, CLEAR_SURVEY_FORM_DATA, DELETE_SURVEY_FAIL, DELETE_SURVEY_REQUEST, DELETE_SURVEY_SUCCESS, DUPLICATE_SURVEY_FAIL, DUPLICATE_SURVEY_REQUEST, DUPLICATE_SURVEY_SUCCESS, GET_SURVEY_FAIL, GET_SURVEY_LIST_DATA_FAIL, GET_SURVEY_LIST_DATA_REQUEST, GET_SURVEY_LIST_DATA_SUCCESS, GET_SURVEY_REQUEST, GET_SURVEY_SUCCESS, MOVE_TO_DRAFT_SURVEY_FAIL, MOVE_TO_DRAFT_SURVEY_REQUEST, MOVE_TO_DRAFT_SURVEY_SUCCESS, MOVE_TO_PUBLISH_SURVEY_SUCCESS, MOVE_TO_PUBLISH_SURVEY_FAIL, MOVE_TO_PUBLISH_SURVEY_REQUEST,
    UPDATE_ELOQUA_SETTINGS_REQUEST,
    UPDATE_ELOQUA_SETTINGS_SUCCESS,
    UPDATE_ELOQUA_SETTINGS_FAIL,
    GET_ELOQUA_SETTINGS_FAIL,
    GET_ELOQUA_SETTINGS_SUCCESS,
    GET_ELOQUA_SETTINGS_REQUEST,
    GET_LANGUAGES_REQUEST,
    GET_LANGUAGES_SUCCESS,
    GET_LANGUAGES_FAIL,
    ADD_SURVEY_ASSIGN_TO_REQUEST,
    ADD_SURVEY_ASSIGN_TO_SUCCESS,
    ADD_SURVEY_ASSIGN_TO_FAIL,
    GET_SURVEY_ASSIGN_TO_REQUEST,
    GET_SURVEY_ASSIGN_TO_SUCCESS,
    GET_SURVEY_ASSIGN_TO_FAIL,
     CREATE_WEBHOOK_REQUEST,
  CREATE_WEBHOOK_SUCCESS,
  CREATE_WEBHOOK_FAIL,
    GET_WEBHOOKS_REQUEST,
    GET_WEBHOOKS_SUCCESS,
    GET_WEBHOOKS_FAIL,
    UPDATE_WEBHOOK_REQUEST,
    UPDATE_WEBHOOK_SUCCESS,
    UPDATE_WEBHOOK_FAIL,
    DELETE_WEBHOOK_REQUEST,
    DELETE_WEBHOOK_SUCCESS,
    DELETE_WEBHOOK_FAIL,
    GET_WEBHOOK_EVENTS_REQUEST,
    GET_WEBHOOK_EVENTS_SUCCESS,
    GET_WEBHOOK_EVENTS_FAIL,
    GET_ACTIVE_WEBHOOKS_REQUEST,
    GET_ACTIVE_WEBHOOKS_SUCCESS,
    GET_ACTIVE_WEBHOOKS_FAIL,
    GET_PRIVACY_POLICY_REQUEST,
    GET_PRIVACY_POLICY_SUCCESS,
    GET_PRIVACY_POLICY_FAIL,
    SAVE_PRIVACY_POLICY_REQUEST,
    SAVE_PRIVACY_POLICY_SUCCESS,
    SAVE_PRIVACY_POLICY_FAIL,
    GET_COOKIE_POLICY_REQUEST,
    GET_COOKIE_POLICY_SUCCESS,
    GET_COOKIE_POLICY_FAIL,
    SAVE_COOKIE_POLICY_REQUEST,
    SAVE_COOKIE_POLICY_SUCCESS,
    SAVE_COOKIE_POLICY_FAIL,
    TOGGLE_COOKIE_POLICY_REQUEST,
    TOGGLE_COOKIE_POLICY_SUCCESS,
    TOGGLE_COOKIE_POLICY_FAIL
} from "../constant";


export const getSurveyList = (data) => {
    return async (dispatch) => {
        dispatch({ type: GET_SURVEY_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/getSurveyList`,
            data: data
        })
        if (response) {
            dispatch({ type: GET_SURVEY_SUCCESS, payload: response?.data })

            dispatch({ type: GET_SURVEY_LIST_DATA_REQUEST, payload: response?.data })
            if (response?.data?.data) {
                // console.log('response?.data?.data', response?.data?.data);
                const rawData = response?.data?.data
                const surveyList = rawData?.map((survey) => survey?.survey_id)

                const { response: dataResponse, error: dataError } = await apiRequest({
                    method: 'POST',
                    url: `/survey/getDataSurveyList`,
                    data: {
                        surveyList: surveyList
                    }
                })
                if (dataResponse) {
                    // console.log(dataResponse);
                    dispatch({ type: GET_SURVEY_LIST_DATA_SUCCESS, payload: dataResponse?.data?.data })
                }
                else if (dataError) {
                    dispatch({ type: GET_SURVEY_LIST_DATA_FAIL })
                }
            }
        }
        else if (error) {
            dispatch({ type: GET_SURVEY_FAIL })
        }
    }
}

export const addSurvey = (data, navigate) => {
    return async (dispatch) => {

        dispatch({ type: ADD_SURVEY_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/addSurvey`,
            data: data.addSurveyData
        })
        if (response) {
            let surveyId = response.data?.data?.survey_id
            localStorage.setItem('survey_id', surveyId)

            if (data.sddSectionData?.section?.length > 0) {
                const { response: sectionResponse, error: sectionError } = await apiRequest({
                    method: 'POST',
                    url: `/survey/addSection`,
                    data: { ...data.sddSectionData, su_survey_id: surveyId }
                })
                if (sectionResponse) {
                    navigate('/admin/survey/list')
                    dispatch({ type: ADD_SURVEY_SUCCESS });
                }
                else if (sectionError) {
                    dispatch({ type: ADD_SURVEY_FAIL });
                }
            } else {
                navigate('/admin/survey/list')
                dispatch({ type: ADD_SURVEY_SUCCESS });
            }
        }
        else if (error) {
            dispatch({ type: ADD_SURVEY_FAIL });
        }
    }
}

export const changeAddSurveyFormData = (key, data) => {
    return {
        type: CHANGE_ADD_SURVEY_FORM_DATA,
        payload: { key, data }
    }
}

export const deleteSurvey = (data, successCallback, errorCallback) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_SURVEY_REQUEST });
        const { response, error } = await apiRequest({
            method: 'DELETE',
            url: `/survey/delSurvey`,
            data: data
        })
        if (response) {
            successCallback()
            dispatch({ type: DELETE_SURVEY_SUCCESS });
        }
        else if (error) {
            if (errorCallback) errorCallback()
            dispatch({ type: DELETE_SURVEY_FAIL });
        }
    }
}

export const duplicateSurvey = (data, successCallback, errorCallback) => {
    return async (dispatch) => {
        dispatch({ type: DUPLICATE_SURVEY_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/duplicateSurvey`,
            data: data
        })
        if (response) {
            successCallback()
            dispatch({ type: DUPLICATE_SURVEY_SUCCESS });
        }
        else if (error) {
            if (errorCallback) errorCallback()
            dispatch({ type: DUPLICATE_SURVEY_FAIL });
        }
    }
}

export const moveToDraftSurvey = (data, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: MOVE_TO_DRAFT_SURVEY_REQUEST });
        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updSurveyStatus`,
            data: data
        })
        if (response) {
            successCallback()
            dispatch({ type: MOVE_TO_DRAFT_SURVEY_SUCCESS });
        }
        else if (error) {
            dispatch({ type: MOVE_TO_DRAFT_SURVEY_FAIL });
        }
    }
}

export const moveToPublishSurvey = (data, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: MOVE_TO_PUBLISH_SURVEY_REQUEST });
        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updSurveyStatus`,
            data: data
        })
        if (response) {
            successCallback()
            dispatch({ type: MOVE_TO_PUBLISH_SURVEY_SUCCESS });
        }
        else if (error) {
            dispatch({ type: MOVE_TO_PUBLISH_SURVEY_FAIL });
        }
    }
}

export const clearSurveyFormData = () => {
    return { type: CLEAR_SURVEY_FORM_DATA }
}


export const updateEloquaSettings = (data, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_ELOQUA_SETTINGS_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/updSurveyEloquaSetting`,
            data: data
        });
        if (response) {
            dispatch({ type: UPDATE_ELOQUA_SETTINGS_SUCCESS, payload: response.data });
            if (successCallback) successCallback();  // Optional: Execute callback on success
        } else if (error) {
            dispatch({ type: UPDATE_ELOQUA_SETTINGS_FAIL, payload: error.message });
        }
    };
};
export const getEloquaSettings = (data, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: GET_ELOQUA_SETTINGS_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/getEloquaActive`,
            data: data
        });
        if (response) {
            dispatch({ type: GET_ELOQUA_SETTINGS_SUCCESS, payload: response.data });
            if (successCallback) successCallback();  // Optional: Execute callback on success
        } else if (error) {
            dispatch({ type: GET_ELOQUA_SETTINGS_FAIL, payload: error.message });
        }
    };
};


// Fetch all languages
export const getLanguages = () => {
    return async (dispatch) => {
        dispatch({ type: GET_LANGUAGES_REQUEST });

        const { response, error } = await apiRequest({
            method: 'GET',
            url: `/survey/getAllLanguages`,
        });

        if (response) {
            dispatch({ type: GET_LANGUAGES_SUCCESS, payload: response.data });
        } else if (error) {
            dispatch({ type: GET_LANGUAGES_FAIL });
        }
    };
};


// Action to add survey assignment
export const addSurveyAssignTo = (data) => {
    return async (dispatch) => {
        dispatch({ type: ADD_SURVEY_ASSIGN_TO_REQUEST });

        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/addSurveyAssignTo`,
            data: data
        });

        if (response) {
            dispatch({ type: ADD_SURVEY_ASSIGN_TO_SUCCESS, payload: response.data });
        } else if (error) {
            dispatch({ type: ADD_SURVEY_ASSIGN_TO_FAIL });
        }
    };
};

export const getSurveyAssignTo = (survey_id) => {
    return async (dispatch) => {
        dispatch({ type: GET_SURVEY_ASSIGN_TO_REQUEST });

        // Use your apiRequest helper (or axios/fetch) to make the GET call
        const { response, error } = await apiRequest({
            method: "GET",
            url: `/survey/getSurveyAssignTo/${survey_id}`,
        });

        if (response) {
            // On success, dispatch payload from response
            dispatch({
                type: GET_SURVEY_ASSIGN_TO_SUCCESS,
                payload: response.data, // <-- The entire response from the backend
            });
        } else if (error) {
            // On error, dispatch fail
            dispatch({
                type: GET_SURVEY_ASSIGN_TO_FAIL,
                payload: error, // or error.message
            });
        }
    };
};



export const createWebhook = (data, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_WEBHOOK_REQUEST });

    const { response, error } = await apiRequest({
      method: "POST",
      url: "/survey/createWebhook",
      data,
    });

    if (response?.data?.statusCode === 200) {
      dispatch({ type: CREATE_WEBHOOK_SUCCESS, payload: response.data });
      if (successCallback) successCallback();
    } else {
      dispatch({
        type: CREATE_WEBHOOK_FAIL,
        payload: error || response?.data?.msg || "Webhook creation failed",
      });
    }
  };
};


export const getWebhooks = (survey_id) => {
    return async (dispatch) => {
        dispatch({ type: GET_WEBHOOKS_REQUEST });

        const { response, error } = await apiRequest({
            method: 'GET',
            url: `/survey/getWebhooks/${survey_id}`
        });

        if (response) {
            dispatch({ type: GET_WEBHOOKS_SUCCESS, payload: response.data });
        } else {
            dispatch({ type: GET_WEBHOOKS_FAIL, payload: error });
        }
    };
};


export const updateWebhook = (data, survey_id, webhook_id, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_WEBHOOK_REQUEST });

        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updateWebhook/${survey_id}/${webhook_id}`,
            data
        });

        if (response) {
            dispatch({ type: UPDATE_WEBHOOK_SUCCESS, payload: response.data });
            if (successCallback) successCallback();
        } else {
            dispatch({ type: UPDATE_WEBHOOK_FAIL, payload: error });
        }
    };
};


export const deleteWebhook = (survey_id, webhook_id, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_WEBHOOK_REQUEST });

        const { response, error } = await apiRequest({
            method: 'DELETE',
            url: `/survey/deleteWebhook/${survey_id}/${webhook_id}`
        });

        if (response) {
            dispatch({ type: DELETE_WEBHOOK_SUCCESS, payload: response.data });
            if (successCallback) successCallback();
        } else {
            dispatch({ type: DELETE_WEBHOOK_FAIL, payload: error });
        }
    };
};


export const getWebhookEvents = () => {
  return async (dispatch) => {
    dispatch({ type: GET_WEBHOOK_EVENTS_REQUEST });

    const { response, error } = await apiRequest({
      method: "GET",
      url: "/survey/getWebhookEvents",
    });

    if (response?.data?.statusCode === 200) {
      dispatch({
        type: GET_WEBHOOK_EVENTS_SUCCESS,
        payload: response.data, // contains `data` object with events
      });
    } else {
      dispatch({
        type: GET_WEBHOOK_EVENTS_FAIL,
        payload: error || response?.data?.msg || "Unknown error",
      });
    }
  };
};


export const getActiveWebhooks = (survey_id) => {
  return async (dispatch) => {
    dispatch({ type: GET_ACTIVE_WEBHOOKS_REQUEST });

    const { response, error } = await apiRequest({
      method: 'GET',
      url: `/survey/getActiveWebhooks/${survey_id}`,
    });

    if (response) {
      dispatch({ type: GET_ACTIVE_WEBHOOKS_SUCCESS, payload: response.data });
    } else {
      dispatch({ type: GET_ACTIVE_WEBHOOKS_FAIL, payload: error });
    }
  };
};

// Privacy Policy
export const getPrivacyPolicy = (survey_id) => {
  return async (dispatch) => {
    dispatch({ type: GET_PRIVACY_POLICY_REQUEST });
    const { response, error } = await apiRequest({
      method: 'GET',
      url: `/survey/getPrivacyPolicy/${survey_id}`,
    });
    if (response) {
      dispatch({ type: GET_PRIVACY_POLICY_SUCCESS, payload: response.data });
    } else {
      dispatch({ type: GET_PRIVACY_POLICY_FAIL, payload: error });
    }
  };
};

export const savePrivacyPolicy = (survey_id, html, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: SAVE_PRIVACY_POLICY_REQUEST });
    const { response, error } = await apiRequest({
      method: 'POST',
      url: `/survey/savePrivacyPolicy`,
      data: { survey_id, privacy_content: html }
    });
    if (response) {
      dispatch({ type: SAVE_PRIVACY_POLICY_SUCCESS, payload: response.data });
      if (successCallback) successCallback();
    } else {
      dispatch({ type: SAVE_PRIVACY_POLICY_FAIL, payload: error });
    }
  };
};

// Cookie Policy
export const getCookiePolicy = (survey_id) => {
  return async (dispatch) => {
    dispatch({ type: GET_COOKIE_POLICY_REQUEST });
    const { response, error } = await apiRequest({
      method: 'GET',
      url: `/survey/getCookiePolicy/${survey_id}`,
    });
    if (response) {
      dispatch({ type: GET_COOKIE_POLICY_SUCCESS, payload: response.data });
    } else {
      dispatch({ type: GET_COOKIE_POLICY_FAIL, payload: error });
    }
  };
};

export const saveCookiePolicy = (survey_id, html, is_enabled, buttonSettings, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: SAVE_COOKIE_POLICY_REQUEST });
    const { response, error } = await apiRequest({
      method: 'POST',
      url: `/survey/saveCookiePolicy`,
      data: {
        survey_id, cookie_content: html, is_enabled,
        accept_btn_enabled: buttonSettings?.accept_btn_enabled ?? true,
        accept_btn_text: buttonSettings?.accept_btn_text || '',
        reject_btn_enabled: buttonSettings?.reject_btn_enabled ?? true,
        reject_btn_text: buttonSettings?.reject_btn_text || '',
      }
    });
    if (response) {
      dispatch({ type: SAVE_COOKIE_POLICY_SUCCESS, payload: response.data });
      if (successCallback) successCallback();
    } else {
      dispatch({ type: SAVE_COOKIE_POLICY_FAIL, payload: error });
    }
  };
};

export const toggleCookiePolicy = (survey_id, is_enabled, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_COOKIE_POLICY_REQUEST });
    const { response, error } = await apiRequest({
      method: 'POST',
      url: `/survey/toggleCookiePolicy`,
      data: { survey_id, is_enabled }
    });
    if (response) {
      dispatch({ type: TOGGLE_COOKIE_POLICY_SUCCESS, payload: { is_enabled } });
      if (successCallback) successCallback();
    } else {
      dispatch({ type: TOGGLE_COOKIE_POLICY_FAIL, payload: error });
    }
  };
};
